// extracted by mini-css-extract-plugin
module.exports = {"container":"InstitutionalHeader_container__MvZzZ","content":"InstitutionalHeader_content__apMPE"};